import {OrderService, AuthService, RegionService} from 'hasta-la-vista-middleware-api/service'
import MetaData from  '../../../mixins/meta-data.js'

export default {
	data(){
        return {
            loading: true,
            user: null,
            subsClub: null,
        }
    },

     methods: {
        setUser(){
            return AuthService.user().then((user)=> {
                this.user = user;
                this.isGuest = user.isGuest();
                if (!user.isGuest() && user.MembershipActivated === false && this.first_time) {
                    // this.cookieActive = false;
                    // this.first_time = false;
                } else {
                    // this.showUserActivation = false;
                }

                return this.user
            })
        },

        getSubsData() {
            let subsClubRaw = window.localStorage.getItem('subsClub');

            let subsClub = null
            if(subsClubRaw && subsClubRaw != undefined) {
                subsClub = JSON.parse(subsClubRaw)
            }

            this.subsClub = subsClub
            return subsClub
        },

        backToPayment() {
            this.$router.push(`/subscribe/2?debitDay=${this.$route.query.debitDay}`)
        },

        backToDetails() {
            this.$router.push('/subscription-club')
        }
    },

	created(){
        Promise.all([this.setUser(), this.getSubsData()]).then(([user, subs])=> {          
            this.loading = false
            // console.log(this.subsClub)
        })
    },
}


// WEBPACK FOOTER //
// ./src/components/pages/subscribe-failure/subscribe-failure.js